import { AccountView } from '../../account-window/account-view';
import { GoogleSignIn } from './google-sign-in';
import { executeLinkAuthMethod } from '../../account-window/parts/execute-link-auth-method';
import { AuthMethod } from '../../account-window/parts/auth-method';

export function initSwitchOnProgressByGoogleEventListener() {
    return initSwitchOnProgressByGoogle();
}
export async function initSwitchOnProgressByGoogle(isBigReward?: boolean): Promise<void> {
    AccountView.hideSocialSwitchAccountError();
    AccountView.showAccountLoadingState();

    const googleSignIn = new GoogleSignIn(window.app.config.google);
    const credentials = await googleSignIn.authenticate();
    // @ts-ignore
    executeLinkAuthMethod(AuthMethod.GOOGLE, credentials, isBigReward);
}
